/**
 * Readiness contract between the CDC Screen-Set block and automated tests.
 *
 * Gigya loads the SDK and renders the selected Screen-Set asynchronously, so
 * `window.gigya.isReady` only tells us the SDK is available - not that a form
 * has been painted. The block publishes these attributes on its container so
 * tests can wait on an application-owned signal instead of guessing with
 * sleeps, `networkidle`, or Gigya's internal markup.
 */

/** `loading` until Gigya reports `onAfterScreenLoad`, then `ready`. */
export const SCREEN_SET_STATUS_ATTRIBUTE = 'data-cdc-screenset-status'

/** Codename of the screen Gigya most recently finished rendering. */
export const SCREEN_SET_SCREEN_ATTRIBUTE = 'data-cdc-screenset-screen'

export type ScreenSetStatus = 'loading' | 'ready'
